export const JARI_FORMAT_VERSION = 1;

export interface JariEnvelope<T = unknown> {
  version: number;
  tool: string;
  exportedAt: string;
  data: T;
}

export function createJariEnvelope<T>(tool: string, data: T): JariEnvelope<T> {
  return {
    version: JARI_FORMAT_VERSION,
    tool,
    exportedAt: new Date().toISOString(),
    data,
  };
}

export function serializeJariFile<T>(tool: string, data: T): string {
  return JSON.stringify(createJariEnvelope(tool, data), null, 2);
}

/** Parse .jari (envelope) or legacy flat JSON into data payload. */
export function parseJariFile<T>(text: string, expectedTool?: string): T {
  const cleaned = text.replace(/^\uFEFF/, "").trim();
  const raw = JSON.parse(cleaned) as Record<string, unknown>;

  if (raw && typeof raw === "object" && "data" in raw && raw.data !== null) {
    const env = raw as JariEnvelope<T>;
    if (expectedTool && env.tool && env.tool !== expectedTool) {
      throw new Error(`Verkeerde tool in bestand: ${env.tool}`);
    }
    return env.data;
  }

  return raw as T;
}

export function downloadJariFile(
  tool: string,
  data: unknown,
  basename: string
): void {
  const base = basename.replace(/\.jari$/i, "").trim() || tool;
  const filename = base.endsWith(".jari") ? base : `${base}.jari`;
  const blob = new Blob([serializeJariFile(tool, data)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function readJariFileFromInput(
  file: File,
  expectedTool?: string
): Promise<string> {
  const text = await file.text();
  parseJariFile(text, expectedTool);
  return text;
}
